import VueYandexMetrika from 'vue-yandex-metrika';

const yandexMetrikaParams = {
  env: process.env.NODE_ENV,
  id: 91528504,
  options: {
    accurateTrackBounce: true,
    clickmap: true,
    trackLinks: true,
    webvisor: false,
  },
};

/**
 * @description Идентификатор цели успешной регистрации.
 * @type {string}
 */
export const GOAL_COMPLETED_REGISTRATION = 'onCompletedRegistration';

/**
 * @description Идентификатор цели смены шага сетки в расписании.
 * @type {string}
 */
export const GOAL_CHANGE_APPOINTMENT_TIMELINE_STEP = 'onChangeAppointmentTimelineStep';

/**
 * @description Идентификатор цели просмотра обновлений приложения.
 * @type {string}
 */
export const GOAL_VIEW_UPDATES_APP = 'onViewUpdatesApp';

/**
 * @description Идентификатор цели нажатия кнопки помощи.
 * @type {string}
 */
export const GOAL_CLICK_HELP_BUTTON = 'onClickHelpButton';

/**
 * @description Идентификатор цели печати медкарты в формате А5.
 * @type {string}
 */
export const GOAL_PRINT_MEDCART_A5 = 'onPrintMedcardA5';

/**
 * @description Обработчики целей.
 * @type {any}
 */
const handlers = {
  [GOAL_COMPLETED_REGISTRATION]() {
    this.$metrika.reachGoal('uspeh');
  },
  [GOAL_CHANGE_APPOINTMENT_TIMELINE_STEP]() {
    this.$metrika.reachGoal('shag');
  },
  [GOAL_VIEW_UPDATES_APP]() {
    this.$metrika.reachGoal('obnovlenia');
  },
  [GOAL_CLICK_HELP_BUTTON]() {
    this.$metrika.reachGoal('pomoch');
  },
  [GOAL_PRINT_MEDCART_A5]() {
    this.$metrika.reachGoal('medcart_a5');
  },
};

/**
 * @description Плагин метрики.
 * @constructor
 * @type {VuePlugin}
 */
export default function VueMetric(logger = console) {
  /**
   * @inheritDoc
   */
  this.install = (Vue) => {
    Vue.use(VueYandexMetrika, yandexMetrikaParams);
    Object.defineProperty(Vue.prototype, '$goal', {
      value(trigger, ...args) {
        const handler = handlers[trigger] || (
          () => logger.warn('uncaught goal of metric:', trigger, ...args)
        );
        handler.bind(this, ...args)();
      },
    });
  };
}
